module.exports = __webpack_public_path__ + "img/download.597977eb.svg";